import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import polygonLogo from "../assets/polygon-logo.png";
import analysisIcon from "../assets/score-analysis-icon.png";
import likeIcon from "../assets/like-icon.png";
import unlikeicon from "../assets/unlike-icon.png";
import trustScoreImage from "../assets/trust-score-img.png";
import apis from "../services";
import { toast } from "react-toastify";
import { FaLock } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import ReactLoading from "react-loading";
import DynamicHeader from "../Header/DynamicHeader";
import { FiCopy } from "react-icons/fi";

const handleCopy = (text) => {
  navigator.clipboard.writeText(text);
  toast.success("Copied to clipboard!");
};

const data = [
  { feature: "Total Supply", id: "total_supply" },
  { feature: "Lp Holders", id: "holder_count" },
  { feature: "Transfer pausable", id: "transfer_pausable" },
  { feature: "Trading Cooldown", id: "trading_cooldown" },
  { feature: "Hidden Owner", id: "hidden_owner" },
  { feature: "Token Percentage of Owner", id: "owner_percent" },
  { feature: "Whitelist", id: "is_whitelisted" },
  { feature: "Blacklist", id: "is_blacklisted" }, //done
  { feature: "Token Holder Number", id: "holder_count" },
  { feature: "Honeypot", id: "is_honeypot" },
  { feature: "Honeypot with same creator", id: "honeypot_with_same_creator" },
  { feature: "Is in DEX", id: "is_in_dex" },
  { feature: "Open Source", id: "is_open_source" },
];

const rightSideData = [
  { feature: "Sell Tax", id: "sell_tax" },
  { feature: "Buy Tax", id: "buy_tax" },
  { feature: "Token Percentage of Creator", id: "creator_percent" },
  { feature: "Proxy Contract", id: "is_proxy" },
  { feature: "Owner Balance", id: "owner_balance" },
  { feature: "Take Back Ownership", id: "can_take_back_ownership" },
  { feature: "Modifiable Tax", id: "slippage_modifiable" },
  { feature: "With External Call", id: "external_call" },
  { feature: "Cannot Sell All", id: "cannot_sell_all" },
  { feature: "LP Token Holder Number", id: "holder_count" },
  {
    feature: "Assigned Address' Slippage is Modifiable",
    id: "personal_slippage_modifiable",
  },
  { feature: "Anti Whale", id: "is_anti_whale" },
  { feature: "Mint Function", id: "is_mintable" },
  { feature: "Owner Can Change Balance", id: "owner_change_balance" },
  { feature: "Cannot Be Bought", id: "cannot_buy" },
  { feature: "Modifiable Anti Whale", id: "anti_whale_modifiable" },
];

const InvestDetails = () => {
  const { tokenaddress } = useParams();
  const [searchParams] = useSearchParams();
  const chainName = searchParams.get("chainName");
  const checkScam = searchParams.get("checkScam");
  const [tokenData, setTokenData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleCheckScam = async () => {
    setLoading(true);
    try {
      const tokenAddressLocalStorage = JSON.parse(
        localStorage.getItem("token-address")
      );
      const tokenFromLocalStorage = JSON.parse(
        localStorage.getItem("token-data")
      );

      if (tokenAddressLocalStorage == tokenaddress) {
        setTokenData(tokenFromLocalStorage);
        setLoading(false);
        return;
      } else {
        setError(true);
      }

      const response = await apis.getDetails(tokenaddress);

      if (response.status === 200) {
        setTokenData(response.data);
      } else {
        toast.error("Invalid response from API");
        setError(true);
      }
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error("Record not found, will get back shortly");
      } else {
        toast.error(err.response?.data?.message || "Something went wrong.");
      }
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchCards = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apis.getTokenById(tokenaddress, chainName);

      if (response) {
        setTokenData(response);
      } else {
        setTokenData({});
      }
    } catch (err) {
      toast.error(err.message);
      setError(err.message || "Failed to fetch data");
      console.error("Error fetching cards:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const getRiskLevel = (score) => {
    if (score >= 100)
      return { stars: "⭐⭐⭐⭐⭐", remarks: "Excellent - Highly investable" };
    if (score >= 80)
      return { stars: "⭐⭐⭐⭐", remarks: "Good - Investable with caution" };
    if (score >= 60)
      return {
        stars: "⭐⭐⭐",
        remarks: "Moderate - Medium risk, requires due diligence",
      };
    if (score >= 40)
      return { stars: "⭐⭐", remarks: "Risky - High-risk investment" };
    return { stars: "⭐", remarks: "Avoid - Not investable" };
  };
  useEffect(() => {
    if (checkScam == "true") {
      handleCheckScam();
    } else {
      fetchCards();
    }
  }, [checkScam, tokenaddress]);

  return (
    <div className="main-invest-details">
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100vw",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
          }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      ) : error ? (
        <div className="record">
          No worries, we're updating the details and they’ll be available for
          you shortly!.
        </div>
      ) : (
        <>
          {/* <div className="header-container">
           <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna"> Lookna </span><br></br><br></br>
              
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
  
            </h2>
          
          </div>
          <div className="details-borders"></div>
       
        </div>
     
          </div> */}
          <DynamicHeader />
          <div className="custom-back-btn">
            <Link to={"/DEX"}>
              <button type="submit">
                <IoIosArrowBack /> Back
              </button>
            </Link>
          </div>

          <div className="invest-details">
            <div className="top">
              <div className="left">
                <div className="heading-left">
                  <h2>{tokenData?.tokenName || "-"}</h2>
                </div>

                <div className="price">
                  <p>
                    <b>Price:</b>
                  </p>
                  <p>{tokenData?.price || "-"}</p>
                </div>

                {/* <div className="token-address">
                  <p>
                    <b>Token Address:</b>
                  </p>
                  <p>{tokenaddress}</p>
               
                </div>

                {Number(tokenData?.isLookna || "-") !== 0 && (
                  <div className="peer-address">
                    <p>
                      <b>Pair Address:</b>
                    </p>
                    <p>{tokenData?.pairAddress || "-"}</p>
                
                  </div>
                )} */}
                <div className="token-address">
                  <p>
                    <b>Token Address:</b>
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <p style={{ margin: 0 }}>{tokenaddress}</p>
                    <FiCopy
                      style={{ cursor: "pointer" }}
                      onClick={() => handleCopy(tokenaddress)}
                      title="Copy Token Address"
                    />
                  </div>
                </div>

                {Number(tokenData?.isLookna || "-") !== 0 && (
                  <div className="peer-address">
                    <p>
                      <b>Pair Address:</b>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <p style={{ margin: 0 }}>
                        {tokenData?.pairAddress || "-"}
                      </p>
                      {tokenData?.pairAddress && (
                        <FiCopy
                          style={{ cursor: "pointer" }}
                          onClick={() => handleCopy(tokenData?.pairAddress)}
                          title="Copy Pair Address"
                        />
                      )}
                    </div>
                  </div>
                )}

                <div className="single-vault-detail">
                  <div>
                    <div className="liquidity">
                      <p>
                        <b>Price</b>
                      </p>
                      <p>
                        {tokenData?.price || "-" == "-" ? "" : "$ "}
                        {tokenData.price.length > 30
                          ? tokenData.price.slice(0, 30) +
                            "\n" +
                            tokenData.price.slice(30)
                          : tokenData.price}
                      </p>
                    </div>
                  </div>

                  <div>
                    {Number(tokenData?.isLookna || "-") !== 0 && (
                      <div className="liquidity">
                        <p>
                          <b>FDV</b>
                        </p>
                        <p style={{ textWrap: "nowrap", fontSize: "12px" }}>
                          {tokenData.price == "-" ? "" : "$ "}
                          {tokenData.price.length > 10
                            ? tokenData.fdv.slice(0, 20) +
                              "\n" +
                              tokenData.fdv.slice(20)
                            : tokenData.fdv}
                        </p>
                      </div>
                    )}

                    {Number(tokenData?.isLookna) !== 0 && (
                      <div className="holders">
                        <p>
                          <b>
                            Liquidity{" "}
                            {Number(
                              tokenData?.tokenDetails?.lp_holders &&
                                tokenData?.tokenDetails?.lp_holders[0]
                                  ?.is_locked
                            ) !== 0 ? (
                              <FaLock />
                            ) : (
                              ""
                            )}
                          </b>
                        </p>
                        {tokenData.liquidity > 20 ? (
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            ${tokenData.liquidity.toString()}
                          </p>
                        ) : (
                          <p>${tokenData?.liquidity || "-"}</p>
                        )}
                      </div>
                    )}
                  </div>

                  <div>
                    <div className="ageses">
                      <p>
                        <b>Coin Name</b>
                      </p>
                      <p>{tokenData?.tokenName || "-"}</p>
                    </div>

                    <div className="riskses">
                      <p>
                        <b>Price Provider</b>
                      </p>
                      <p>{tokenData?.priceProvider || "-"}</p>
                    </div>
                  </div>
                </div>
                <div className="card-footer-details">
                  <div className="progresss-bar-border">
                    <div className="progress-bar">
                      <div className="progress-fill"></div>
                    </div>
                  </div>
                </div>
              </div>
              {chainName !== "solana" && (
                <div
                  className="right"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(59, 10, 80, 0.5) 0%, rgba(0, 0, 0, 0.2) 100%)",
                    border: "1px solid",
                  }}
                >
                  <div className="heading-right">
                    <img src={analysisIcon} alt="score analysis" />
                    <h2>LOOKNA SCORE ANALYSIS</h2>
                  </div>
                  <div className="score-analysis-bottom">
                    <table
                      className="alamgir"
                      style={{
                        background:
                          "linear-gradient(180deg, rgba(59, 10, 80, 0.5) 0%, rgba(0, 0, 0, 0.2) 100%)",
                        border: "1px solid #E5E7EB",
                        borderRadius: "12px",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        overflow: "hidden",
                      }}
                    >
                      <tr className="asasasasasasasasas">
                        <td style={{ textWrap: "nowrap" }}>
                          With Hidden Owner
                        </td>
                        <td>
                          {Number(tokenData.tokenDetails.hidden_owner) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.hidden_owner) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Self-Destruct</td>
                        <td>
                          {Number(tokenData.tokenDetails.selfdestruct) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.selfdestruct) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Honeypot</td>
                        <td>
                          {Number(tokenData.tokenDetails.is_honeypot) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.is_honeypot) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ textWrap: "nowrap" }}>
                          Honeypot with Creator
                        </td>
                        <td>
                          {Number(
                            tokenData.tokenDetails.honeypot_with_same_creator
                          ) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(
                                tokenData.tokenDetails
                                  .honeypot_with_same_creator
                              ) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Proxy Contract</td>
                        <td>
                          {Number(tokenData.tokenDetails.is_proxy) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.is_proxy) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Cannot Be Bought</td>
                        <td>
                          {Number(tokenData.tokenDetails.cannot_buy) == 0
                            ? "No"
                            : "Yes"}
                        </td>

                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.cannot_buy) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr className="">
                        <td className="">Total Score</td>
                        <td>
                          <span>{tokenData.totalScore}%</span>
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td>Rating</td>
                        <td
                          className="risk-indicator"
                          style={{
                            color:
                              tokenData.totalScore >= 100
                                ? "green"
                                : tokenData.totalScore >= 80
                                ? "green"
                                : tokenData.totalScore >= 60
                                ? "yellow"
                                : tokenData.totalScore >= 40
                                ? "red"
                                : "red",
                          }}
                        >
                          <span style={{ marginLeft: "-6px" }}>
                            {getRiskLevel(tokenData.totalScore)?.stars}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td
                          className="risk-indicator"
                          style={{
                            color:
                              tokenData.totalScore >= 100
                                ? "green"
                                : tokenData.totalScore >= 80
                                ? "green"
                                : tokenData.totalScore >= 60
                                ? "yellow"
                                : tokenData.totalScore >= 40
                                ? "red"
                                : "red",
                            textAlign: "start",
                          }}
                        >
                          <span>
                            {getRiskLevel(tokenData.totalScore)?.remarks}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              )}
              {chainName === "solana" && (
                <div className="right">
                  <div className="heading-right">
                    <img src={analysisIcon} alt="score analysis" />
                    <h2>LOOKNA SCORE ANALYSIS</h2>
                  </div>
                  <div className="score-analysis-bottom">
                    <table>
                      <tr className="asasasasasasasasas">
                        <td style={{ textWrap: "nowrap" }}>Liquidity Score</td>
                        <td>
                          {tokenData.tokenDetails.dexDetails?.[0]?.tvl || "0"}
                        </td>

                        <td>
                          <img
                            src={
                              Number(
                                tokenData.tokenDetails.dexDetails?.[0]?.tvl
                              )
                                ? likeIcon
                                : unlikeicon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Holder Distribution</td>
                        <td>
                          {`${
                            tokenData.tokenDetails.holders?.[0]?.percent || "0"
                          }%`}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.selfdestruct) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Locked LP Tokens</td>
                        <td>
                          {`${
                            tokenData.tokenDetails.lp_holders?.[0]?.percent ||
                            "0"
                          }`}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.is_honeypot) == 0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ textWrap: "nowrap" }}>Transferability</td>
                        <td>
                          {Number(tokenData.tokenDetails.non_transferable) == 0
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              Number(tokenData.tokenDetails.non_transferable) ==
                              0
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Mintability</td>
                        <td>
                          {tokenData.tokenDetails.mintable?.status === "0"
                            ? "No"
                            : "Yes"}
                        </td>
                        <td>
                          <img
                            src={
                              tokenData.tokenDetails.mintable?.status === "0"
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Freeze Authority</td>
                        <td>
                          {Number(
                            tokenData.tokenDetails.freezable?.status === "0"
                          )
                            ? "No"
                            : "Yes"}
                        </td>

                        <td>
                          <img
                            src={
                              Number(
                                tokenData.tokenDetails.freezable?.status === "0"
                              )
                                ? unlikeicon
                                : likeIcon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Metadata Accuracy</td>
                        <td>
                          {tokenData.tokenDetails.metadata?.name &&
                          tokenData.tokenDetails?.metadata?.symbol
                            ? "Yes"
                            : "No"}
                        </td>

                        <td>
                          <img
                            src={
                              tokenData.tokenDetails.metadata?.name &&
                              tokenData.tokenDetails?.metadata?.symbol
                                ? likeIcon
                                : unlikeicon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Security Factors</td>
                        <td>
                          {tokenData.tokenDetails.creators?.some(
                            (creator) => creator.malicious_address === 1
                          )
                            ? "Yes"
                            : "No"}
                        </td>

                        <td>
                          <img
                            src={
                              tokenData.tokenDetails.creators?.some(
                                (creator) => creator.malicious_address === 1
                              )
                                ? likeIcon
                                : unlikeicon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Trusted Token Flag</td>
                        <td>
                          {Number(tokenData.trusted_token === 1) ? "Yes" : "No"}
                        </td>

                        <td>
                          <img
                            src={
                              Number(tokenData.trusted_token === 1)
                                ? likeIcon
                                : unlikeicon
                            }
                            alt="status icon"
                          />
                        </td>
                      </tr>
                      <tr className="">
                        <td className="">Total Score</td>
                        <td>
                          <span>{tokenData.totalScore}%</span>
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td>Rating</td>
                        <td
                          className="risk-indicator"
                          style={{
                            color:
                              tokenData.totalScore >= 100
                                ? "green"
                                : tokenData.totalScore >= 80
                                ? "green"
                                : tokenData.totalScore >= 60
                                ? "yellow"
                                : tokenData.totalScore >= 40
                                ? "red"
                                : "red",
                          }}
                        >
                          <span style={{ marginLeft: "-6px" }}>
                            {getRiskLevel(tokenData.totalScore)?.stars}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Remarks</td>
                        <td
                          className="risk-indicator"
                          style={{
                            color:
                              tokenData.totalScore >= 100
                                ? "green"
                                : tokenData.totalScore >= 80
                                ? "green"
                                : tokenData.totalScore >= 60
                                ? "yellow"
                                : tokenData.totalScore >= 40
                                ? "red"
                                : "red",
                            textAlign: "start",
                          }}
                        >
                          <span>
                            {getRiskLevel(tokenData.totalScore)?.remarks}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
          {chainName !== "solana" && (
            <div className="table-container">
              <div className="table">
                <div className="left-column">
                  {data.map((item, index) => (
                    <div key={index} className="row" id={item.id}>
                      <div className="row-list-style">
                        <span className="list-style">• </span>
                        <span className="feature">{item.feature}</span>
                      </div>
                      <span className="value">
                        {Number(tokenData.tokenDetails[item.id]) == 0
                          ? "No"
                          : "Yes"}
                        <img
                          src={
                            Number(tokenData.tokenDetails[item.id]) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </span>
                    </div>
                  ))}
                </div>

                <div className="right-column">
                  {rightSideData.map((item, index) => (
                    <div key={index} className="row" id={item.id}>
                      <div className="row-list-style">
                        <span className="list-style">• </span>
                        <span className="feature">{item.feature}</span>
                      </div>
                      <span className="value">
                        {Number(tokenData.tokenDetails[item.id]) == 0
                          ? "No"
                          : "Yes"}
                        <img
                          src={
                            Number(tokenData.tokenDetails[item.id]) == 0
                              ? unlikeicon
                              : likeIcon
                          }
                          alt="status icon"
                        />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default InvestDetails;
